import { useRef, useEffect } from 'react';
import useCallbackRef from 'hooks/useCallbackRef';
function useFocusOnMount() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    onFocus = _ref.onFocus,
    onRestoreFocus = _ref.onRestoreFocus,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    userRef = _ref.ref;
  var innerRef = useRef(null);
  var previouslyFocusedElementRef = useRef(null);
  var onFocusRef = useCallbackRef(onFocus);
  var onRestoreFocusRef = useCallbackRef(onRestoreFocus);
  useEffect(function () {
    var ref = userRef || innerRef;
    var restoreFocus = onRestoreFocusRef.current;
    if (!disabled) {
      var _ref$current;
      previouslyFocusedElementRef.current = document.activeElement;
      (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.focus();
      if (onFocusRef.current && ref.current) {
        onFocusRef.current(ref.current);
      }
    }
    return function () {
      if (!disabled) {
        var _previouslyFocusedEle;
        (_previouslyFocusedEle = previouslyFocusedElementRef.current) === null || _previouslyFocusedEle === void 0 ? void 0 : _previouslyFocusedEle.focus();
        if (restoreFocus) {
          restoreFocus(previouslyFocusedElementRef.current);
        }
      }
    };
  }, [disabled, onFocusRef, onRestoreFocusRef, userRef]);
  return innerRef;
}
export default useFocusOnMount;